const initialState = {
  model: null,
  detailsHTML: null,
};

const errorMessage = "Hmm... something's not right... Error fetching data.";

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "SET_STAKEHOLDER":
      return {
        ...state,
        model: action.data,
        detailsHTML: null,
      };

    case "FETCH_STAKEHOLDER_FULFILLED":
      return {
        ...state,
        detailsHTML: action.data
      };

    case "FETCH_STAKEHOLDER_REJECTED":
      return {
        ...state,
        detailsHTML: errorMessage
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
